import { BusinessFrontPageHighlightType } from '@/models/businesses/business-front-page-highlight';
import { axiosService } from '..';

export default class GetBusinessFrontPageHighlightService {
    public async execute(businessId: number, uniqueIdentifier: string): Promise<GetBusinessFrontPageHighlightServiceOutputDto> {
        return new GetBusinessFrontPageHighlightServiceOutputDto((await axiosService.instance.get(`businesses/organization/front-page/${businessId}/highlight?uniqueIdentifier=${uniqueIdentifier}`)).data);
    }
}

export class GetBusinessFrontPageHighlightServiceOutputDto {
    public readonly uniqueIdentifier: string;
    public readonly title: string | null;
    public readonly value: number | null;
    public readonly imageUrl: string | null;
    public readonly type: BusinessFrontPageHighlightType;

    constructor(data: any) {
        this.uniqueIdentifier = data.uniqueIdentifier;
        this.title = data.title;
        this.value = data.value;
        this.imageUrl = data.imageUrl;
        this.type = BusinessFrontPageHighlightType[BusinessFrontPageHighlightType[data.type] as keyof typeof BusinessFrontPageHighlightType];
    }
}

export const getBusinessFrontPageHighlightService = new GetBusinessFrontPageHighlightService();
